export default class Counter {
  constructor(el, duration = 600, onComplete = null) {
    this.el = el;
    this.onComplete = onComplete;
    this.animated = false;

    const numAttr = el.getAttribute('data-num');
    const suffixAttr = el.getAttribute('data-suffix') || '';
    this.raw = el.getAttribute('data-raw') || el.textContent.trim();

    // Use parseFloat to handle decimal targets (e.g., 2.9)
    let num = numAttr ? parseFloat(numAttr) : null; 
    let suffix = suffixAttr;

    if (num == null || Number.isNaN(num)) {
      // RegEx captures the full number (with optional decimals) in m[1]
      const m = this.raw.match(/^(\d+(\.\d+)?)\s*([kKmM]?)(\+?)$/); 
      
      if (m) {
        num = parseFloat(m[1]);
        suffix = (m[3] || '') + (m[4] || '');
      } else {
        num = 0;
      }
    }

    this.target = num;
    this.suffix = suffix;

    // --- REVERTED TO ORIGINAL START LOGIC ---
    // Logic to determine the starting number (realStart) based on target value
    if (this.target > 150) {
      this.realStart = 120;
    } else if (this.target > 20 && this.target <= 150) {
      this.realStart = 10;
    } else if (this.target > 10 && this.target <= 20) {
      this.realStart = 5;
    } else {
      this.realStart = 0;
    }
    // --- END ORIGINAL START LOGIC ---
    
    // Ensure the start value is not greater than the target itself
    if (this.realStart >= this.target) {
        this.realStart = 0;
    }

    this.start = this.realStart;
    this.duration = duration;
    this.startTs = null;

    // Format initial value: integer if target is integer, one decimal otherwise.
    const initialValue = Number.isInteger(this.target) ? this.start : this.start.toFixed(1);

    this.el.textContent = `${initialValue}${this.suffix}`;

    // IntersectionObserver setup: start animation when element is visible
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
      });
      this.observer.observe(this.el);
    } else {
      // Fallback: start animation immediately
      this.startAnimation();
    }
  }

  handleIntersect(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting && !this.animated) {
        this.startAnimation();
        this.animated = true;
        observer.unobserve(this.el);
      }
    });
  }

  startAnimation() {
    // Synchronization logic: set a global start time for all counters in the block.
    if (!window.counterBlockStartTime) {
        window.counterBlockStartTime = performance.now();
    }
    this.startTs = window.counterBlockStartTime;

    requestAnimationFrame(this.step.bind(this));
  }

  step(ts) {
    if (!this.startTs) this.startTs = ts;

    const elapsed = ts - this.startTs;
    const progress = Math.min(elapsed / this.duration, 1);

    const rawValue = this.start + (progress) * (this.target - this.start);

    let value;
    if (Number.isInteger(this.target)) {
        // FINAL SYNCHRONIZATION FIX: Use Math.floor() to prevent the integer counter 
        // from visually finishing early, aligning it with the decimal counter's duration.
        value = Math.min(Math.floor(rawValue), this.target);
    } else {
        // For decimals, use toFixed(1) for smooth display.
        value = rawValue.toFixed(1); 
    }

    this.el.textContent = `${value}${this.suffix}`;

    if (progress < 1) {
      requestAnimationFrame(this.step.bind(this));
    } else {
      // Ensure the final value is displayed exactly (only when progress = 1)
      const finalValue = Number.isInteger(this.target) ? this.target : this.target.toFixed(1);
      
      this.el.textContent = `${finalValue}${this.suffix}`;
      this.el.setAttribute('data-final', `${finalValue}${this.suffix}`);
      
      if (typeof this.onComplete === 'function') {
        this.onComplete();
      }
    }
  }
}